import React from "react";

const Testimonials = () => {
  const testimonials = [
    {
      name: "Sarah Ahmed",
      role: "IELTS Student",
      image: "/images/hero-student.png",
      rating: 5,
      text: "Rashida ma'am helped me achieve my target IELTS score of 7.5. Her teaching methods are incredibly effective and she provides excellent feedback.",
      achievement: "IELTS 7.5",
    },
    {
      name: "Mohammad Rahman",
      role: "Business Professional",
      image: "/images/hero-student.png",
      rating: 5,
      text: "The business English course transformed my communication skills. I got promoted within 6 months of completing the course!",
      achievement: "Career Growth",
    },
    {
      name: "Fatima Khan",
      role: "University Student",
      image: "/images/hero-student.png",
      rating: 5,
      text: "Ma'am's grammar lessons are so clear and easy to understand. My writing skills improved dramatically in just 3 months.",
      achievement: "Academic Success",
    },
    {
      name: "Ahmed Hassan",
      role: "Job Seeker",
      image: "/images/hero-student.png",
      rating: 5,
      text: "Thanks to the interview preparation sessions, I landed my dream job at a multinational company. Highly recommended!",
      achievement: "Dream Job",
    },
  ];

  return (
    <section id="testimonials" className="py-20 bg-white dark:bg-gray-900">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16" data-aos="fade-up">
          <h2 className="text-4xl lg:text-6xl font-bold font-display mb-6">
            Student <span className="gradient-text">Success Stories</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Hear from my students who have achieved their English learning goals
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-slate-50 to-blue-50 rounded-3xl p-8 shadow-xl card-hover"
              data-aos="fade-up"
              data-aos-delay={index * 200}
            >
              <div
                className="flex items-center space-x-4 mb-6"
                data-aos="fade-right"
                data-aos-delay={index * 200 + 200}
              >
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-16 h-16 rounded-full object-cover border-4 border-white shadow-lg"
                />
                <div>
                  <h4 className="text-xl font-bold font-display text-gray-800">
                    {testimonial.name}
                  </h4>
                  <p className="text-gray-600">{testimonial.role}</p>
                  <div className="flex items-center space-x-1 mt-1">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <span
                        key={i}
                        className="text-yellow-500"
                        data-aos="zoom-in"
                        data-aos-delay={index * 200 + 300 + i * 50}
                      >
                        ⭐
                      </span>
                    ))}
                  </div>
                </div>
              </div>

              <blockquote
                className="text-gray-700 leading-relaxed mb-6 italic"
                data-aos="fade-up"
                data-aos-delay={index * 200 + 400}
              >
                "{testimonial.text}"
              </blockquote>

              <div
                className="flex items-center justify-between"
                data-aos="fade-up"
                data-aos-delay={index * 200 + 500}
              >
                <span className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-4 py-2 rounded-full text-sm font-semibold">
                  🎉 {testimonial.achievement}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center" data-aos="fade-up" data-aos-delay="800">
          <div className="bg-gradient-to-r from-indigo-600 to-purple-600 rounded-3xl p-12 text-white">
            <h3
              className="text-3xl font-bold font-display mb-4"
              data-aos="fade-up"
              data-aos-delay="1000"
            >
              Ready to Start Your Success Story?
            </h3>
            <p
              className="text-xl mb-8 opacity-90"
              data-aos="fade-up"
              data-aos-delay="1200"
            >
              Join hundreds of successful students who have achieved their
              English learning goals
            </p>
            <button
              className="bg-white text-indigo-600 px-8 py-4 rounded-full font-semibold hover:bg-gray-100 transition-all transform hover:scale-105 shadow-lg"
              data-aos="zoom-in"
              data-aos-delay="1400"
            >
              Start Your Journey Today
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
